<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button color="medium" (click)="cancel()">
				<ion-icon name="arrow-back-outline" slot="start"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>{{ 'MODAL.CHANGE-TRIP.TITLE' | translate }}</ion-title>
		<ion-buttons slot="end">
			<ion-button color="success" (click)="addTrip()">
				<ion-icon size="large" name="add-circle"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
	<ion-list>
		@for (trip of this.tripService.remoteTripsHeaders.values(); track trip) {
			<ion-item (click)="confirm(trip.id)">
				<ion-icon class="state-ic" [name]="trip.icon" slot="start"></ion-icon>
				<ion-label>
					{{ trip.title }}
				</ion-label>
				<ion-icon slot="end" class="trash-ic" name="trash"
					(click)="this.tripService.removeTrip(trip.id)"></ion-icon>
			</ion-item>
		}
	</ion-list>
	<ion-button class="add-row" fill="outline" expand="block" (click)="this.tripService.openAddTripModal()">
		<ion-icon slot="start" name="add"></ion-icon>
		{{ 'MODAL.ADD-TRIP.TITLE' | translate }}
	</ion-button>
</ion-content>